<template>
  <StackLayout class="wrapper" role="dialog" aria-modal="true">
    <AgCaption noMargin v-if="titleText" :text="titleText" :id="titleId" />
    <div role="listbox" :aria-labelledby="titleText ? titleId : null" aria-label="Optionen">
      <AgButton 
        embedded 
        dark 
        flat 
        small 
        action 
        v-for="(item, index) in items" 
        :key="index" 
        :icon="item.icon" 
        :text="item.label" 
        role="option"
        :aria-label="item.label"
        tabindex="0"
        @click="done(item)"
        @keydown="handleKeydown($event, item)"
      />
    </div>
    <FlexboxLayout class="actions" v-if="showActions" justifyContent="center" role="group" aria-label="Aktionen">
      <AgButton outlined small icon="times" @click="done" aria-label="Abbrechen" />
    </FlexboxLayout>
  </StackLayout>
</template>

<script>

export default {
  props: {
    titleText: {
      type: String
    },
    cancelText: {
      type: String
    },
    items: {
      type: Array,
      default: () => ([])
    },
    titleId: {
      type: String,
      default: 'select-title'
    }
  },
  computed: {
    showActions () {
      return this.cancelText && this.cancelText.length
    }
  },
  methods: {
    done (event) {
      this.$emit('done', event)
    },
    handleKeydown(event, item) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.done(item);
      }
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .wrapper .caption {
    padding: 20px;
  }

  .wrapper .actions {
    padding: 20px;
  }
}

</style>